'use client';

import * as React from 'react';
import { useQueryParams } from 'hooks/use-query-params';
import { toast } from 'ui';

export function LoginError(): JSX.Element | null {
  const error = useQueryParams('error');
  React.useEffect(() => {
    if (!error) {
      return;
    }
    const err = SIGN_IN_ERRORS[error as 'Signin'];
    if (!err) {
      console.warn(`Unknown login error`, error);
      return;
    }
    toast.error(err);
  }, [error]);
  return null;
}

export const SIGN_IN_ERRORS = {
  Signin: 'Try signing in with a different account.',
  OAuthSignin: 'Try signing in with a different account.',
  OAuthCallback: 'Try signing in with a different account.',
  OAuthCreateAccount: 'Try signing in with a different account.',
  EmailCreateAccount: 'Try signing in with a different account.',
  Callback: 'Try signing in with a different account.',
  OAuthAccountNotLinked:
    'To confirm your identity, sign in with the same account you used originally.',
  EmailSignin: 'Check your email inbox.',
  CredentialsSignin:
    'Sign in failed. Check the details you provided are correct.',
  Default: 'Unable to sign in.',
};
